import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  IAutocompleterTemplateComponent,
} from 'core-app/shared/components/autocompleter/op-autocompleter/op-autocompleter.component';

@Component({
  templateUrl: './attachment-autocompleter-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentAutocompleterTemplateComponent implements IAutocompleterTemplateComponent {
  @ViewChild('optionTemplate') optionTemplate:TemplateRef<Element>;
  @ViewChild('labelTemplate') labelTemplate?:TemplateRef<Element>;
}
